/* eslint-disable no-undef */
import { registerComponent } from "helpers";
import WYATTElement from "wyatt";
import { loadGoogleMaps } from "wyatt-store-locations-gmap-loader";

registerComponent(
  "store-locations-map",
  class StoreLocationsMap extends WYATTElement {
    constructor() {
      super();
      this.map = null;

      this.markers = [];
      this.cards = [];
      this.activeIndex = -1;
    }

    connectedCallback() {
      this.config = this.getComponentConfig({
        defaultLat: 32.7767,
        defaultLng: -96.797,
        defaultZoom: 10,
        apiKey: "",
      });

      this.mapEl = this.querySelector("[data-map]");
      this.allCards = Array.from(
        this.querySelectorAll(".store-locations__card"),
      );
      this.cards = Array.from(
        this.querySelectorAll(".store-locations__card[data-lat]"),
      );

      loadGoogleMaps(this.config.apiKey).then(() => this.setup());
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.markers.forEach((entry) => {
        entry.marker.setMap(null);
      });
      this.markers = [];
      this.map = null;
    }

    setup() {
      if (!this.mapEl) return;

      const center = {
        lat: parseFloat(this.config.defaultLat),
        lng: parseFloat(this.config.defaultLng),
      };

      this.map = new google.maps.Map(this.mapEl, {
        center,
        zoom: this.config.defaultZoom || 10,
        mapTypeControl: false,
        streetViewControl: false,
      });

      const bounds = new google.maps.LatLngBounds();
      let hasValidMarkers = false;

      this.cards.forEach((card, index) => {
        const lat = parseFloat(card.getAttribute("data-lat"));
        const lng = parseFloat(card.getAttribute("data-lng"));
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const position = { lat, lng };
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          title:
            card.querySelector(".store-locations__name")?.textContent.trim() ||
            "",
        });

        marker.addListener("click", () => this.setActive(index));

        this.markers.push({ marker, index });
        bounds.extend(position);
        hasValidMarkers = true;

        card.addEventListener("click", (e) => {
          if (e.target.closest("a, button")) return;
          this.setActive(index);
        });
      });

      if (hasValidMarkers) {
        this.map.fitBounds(bounds);

        google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        });
      }
    }

    setActive(index) {
      if (this.activeIndex >= 0 && this.cards[this.activeIndex]) {
        this.cards[this.activeIndex].classList.remove(
          "store-locations__card--active",
        );
      }

      this.activeIndex = index;

      if (this.cards[index]) {
        this.cards[index].classList.add("store-locations__card--active");
        this.cards[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const entry of this.markers) {
        if (entry.index === index) {
          this.map.panTo(entry.marker.getPosition());
          entry.marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => entry.marker.setAnimation(null), 1400);
          break;
        }
      }
    }
  },
);
